export function formatPhoneInput(value: string): string {
  const formatted = value.replace(/\D/g, '').slice(0, 10)
  if (formatted.length === 0) return ''
  if (formatted.length <= 3) return formatted
  if (formatted.length <= 6) return `(${formatted.slice(0, 3)}) ${formatted.slice(3)}`
  return `(${formatted.slice(0, 3)}) ${formatted.slice(3, 6)}-${formatted.slice(6)}`
}
